import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=5fa461cf&scoped=true"
import script from "./Consulta.vue?vue&type=script&lang=js"
export * from "./Consulta.vue?vue&type=script&lang=js"
import style0 from "./Consulta.vue?vue&type=style&index=0&id=5fa461cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa461cf",
  null
  
)

export default component.exports